import { VerifyEmailForm } from '@/components/verify-email-form'
import { trpc } from '@/lib/trpc'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'

export function VerifyEmailPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const utils = trpc.useUtils()
  const state = location.state as { pendingToken?: string; email?: string } | null

  // Reached without a pending verification (e.g. a direct visit) → nothing to do.
  if (!state?.pendingToken || !state.email) {
    return <Navigate to="/login" replace />
  }

  async function onSuccess() {
    await utils.auth.me.invalidate()
    navigate('/', { replace: true })
  }

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-sm">
        <VerifyEmailForm
          email={state.email}
          pendingToken={state.pendingToken}
          onSuccess={onSuccess}
        />
      </div>
    </div>
  )
}
